/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AddRelationshipRequestDto } from '../model/addRelationshipRequestDto';
// @ts-ignore
import { UpdateRelationshipRequestDto } from '../model/updateRelationshipRequestDto';
// @ts-ignore
import { WorkItemRelationshipsControllerGetRelationships200Response } from '../model/workItemRelationshipsControllerGetRelationships200Response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WorkItemRelationshipsService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Add a relationship to a work item
   * @param workItemId 
   * @param addRelationshipRequestDto 
   */
  public async workItemRelationshipsControllerAddRelationship(workItemId: string, addRelationshipRequestDto: AddRelationshipRequestDto, ): Promise<WorkItemRelationshipsControllerGetRelationships200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemRelationshipsControllerAddRelationship.');
    }
    if (addRelationshipRequestDto === null || addRelationshipRequestDto === undefined) {
      throw new Error('Required parameter addRelationshipRequestDto was null or undefined when calling workItemRelationshipsControllerAddRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships`,
        data: addRelationshipRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Get a relationship by ID
   * @param workItemId 
   * @param relationshipId 
   */
  public async workItemRelationshipsControllerGetRelationshipById(workItemId: string, relationshipId: string, ): Promise<WorkItemRelationshipsControllerGetRelationships200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemRelationshipsControllerGetRelationshipById.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling workItemRelationshipsControllerGetRelationshipById.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * List relationships for a work item
   * @param workItemId 
   */
  public async workItemRelationshipsControllerGetRelationships(workItemId: string, ): Promise<WorkItemRelationshipsControllerGetRelationships200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemRelationshipsControllerGetRelationships.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Remove a relationship
   * @param workItemId 
   * @param relationshipId 
   */
  public async workItemRelationshipsControllerRemoveRelationship(workItemId: string, relationshipId: string, ): Promise<any> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemRelationshipsControllerRemoveRelationship.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling workItemRelationshipsControllerRemoveRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.delete({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Update a relationship
   * @param workItemId 
   * @param relationshipId 
   * @param updateRelationshipRequestDto 
   */
  public async workItemRelationshipsControllerUpdateRelationship(workItemId: string, relationshipId: string, updateRelationshipRequestDto: UpdateRelationshipRequestDto, ): Promise<WorkItemRelationshipsControllerGetRelationships200Response> {
    if (workItemId === null || workItemId === undefined) {
      throw new Error('Required parameter workItemId was null or undefined when calling workItemRelationshipsControllerUpdateRelationship.');
    }
    if (relationshipId === null || relationshipId === undefined) {
      throw new Error('Required parameter relationshipId was null or undefined when calling workItemRelationshipsControllerUpdateRelationship.');
    }
    if (updateRelationshipRequestDto === null || updateRelationshipRequestDto === undefined) {
      throw new Error('Required parameter updateRelationshipRequestDto was null or undefined when calling workItemRelationshipsControllerUpdateRelationship.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.put({
      url: `${this.configuration.basePath}/api/forthbridge-work-management/work-items/${this.configuration.encodeParam({name: "workItemId", value: workItemId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/relationships/${this.configuration.encodeParam({name: "relationshipId", value: relationshipId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateRelationshipRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
